module.exports = __webpack_public_path__ + "img/sidebar-brake.498bbe77.png";